import { loginWithTelegram } from "@/shared/repositories/AuthRepository";
import { getTelegramInitData } from "./telegramAuth";
import { useUserStore } from "@/stores/useUser";
import { useSessionStore } from "@/entities/Session/model";
import { SentryService } from "@/shared/lib/sentry/sentryService";
import { useSubscriptionStore } from "@/entities/Subscription/model/subscriptionStore";
import { usePaymentStore } from "@/entities/Payment/model/paymentStore";

export async function authorize() {
    const userStore = useUserStore();
    const sessionStore = useSessionStore();
    
    const { initData } = getTelegramInitData();

    if (!initData) {
        console.error("Нет данных Telegram для авторизации");
        return null;
    }

    try {
        const authResponse = await loginWithTelegram(initData);
        
        // Сохраняем токен и пользователя
        sessionStore.setToken(authResponse.token);
        userStore.setUser(authResponse.user);

        // Отправляем отчет об успешной авторизации
        SentryService.trackUserAction('Успешная авторизация', {
            user_id: authResponse.user.tg_id,
            username: authResponse.user.username,
            has_balance: authResponse.user.balance > 0
        })

        console.log("Авторизован:", authResponse.user);
        return authResponse.user;
    } catch (error) {
        console.error("Ошибка авторизации", error);
        
        // Отправляем ошибку авторизации в Sentry
        SentryService.trackError(error as Error, {
            action: 'authorize',
            has_init_data: !!initData
        }, 'Ошибка авторизации')
        
        sessionStore.clearToken();
        userStore.clearUser();
        return null;
    }
}

export function logout() {
    const userStore = useUserStore();
    const sessionStore = useSessionStore();
    const subscriptionStore = useSubscriptionStore();
    const paymentStore = usePaymentStore();
    
    // Отправляем отчет о выходе из системы
    SentryService.trackUserAction('Выход из системы', {
        user_id: userStore.user?.tg_id || null,
        username: userStore.user?.username || null
    })
    
    // Очищаем все данные пользователя и токен
    sessionStore.clearToken();
    userStore.clearUser();
    subscriptionStore.clearSubscription();
    paymentStore.clearAll();
    
    console.log("Пользователь разлогинен");
}